export default __webpack_public_path__ + "static/media/logo05.441e9927.svg";